// Maximum length of user-given names (workspace, application, table, view).
// Must match the `max_length` of the `name` fields on the backend models.
export const MAX_NAME_LENGTH = 255

// Maximum length of a workspace description. It is edited in a single-line
// input and rendered as a few lines under the workspace name, so it is bounded
// to what fits there. Must match MAX_WORKSPACE_DESCRIPTION_LENGTH on the
// backend, which is what actually enforces it.
export const MAX_WORKSPACE_DESCRIPTION_LENGTH = 200

// List of values considered as true.
// Compatible with backend/src/baserow/contrib/database/fields/constants.py
export const trueValues = [
  't',
  'T',
  'y',
  'Y',
  'yes',
  'Yes',
  'YES',
  'true',
  'True',
  'TRUE',
  'o', // This one is not on the backend but was on the frontend
  'on',
  'On',
  'ON',
  '1',
  1,
  'checked',
  true,
]

// List of values considered as false.
// Compatible with backend/src/baserow/contrib/database/fields/constants.py
export const falseValues = [
  'f',
  'F',
  'n',
  'N',
  'no',
  'No',
  'NO',
  'false',
  'False',
  'FALSE',
  'off',
  'Off',
  'OFF',
  '0',
  0,
  0.0,
  'unchecked',
  false,
]
